// extracted by mini-css-extract-plugin
export var hidden = "_om-1";
export var visible = "_om-0";